export default class Platform {
  //app下载地址
  static downUrl = "";
  //当前使用的api接口域名
  static address = "";
  //当前平台
  static client = "h5";
  //68
  static down68 = "";
  // 版本号
  static version = 136;
}
